function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
/** @jsxRuntime classic */

/** @jsx jsx */

import { jsx, keyframes } from '@emotion/core';
import { FaSpinner } from 'react-icons/fa';
const spin = keyframes({
  '0%': {
    transform: 'rotate(0deg)'
  },
  '100%': {
    transform: 'rotate(360deg)'
  }
});
const Spinner = /*#__PURE__*/React.memo(props => {
  return jsx(FaSpinner, _extends({
    css: {
      animation: `${spin} 1s linear infinite`
    },
    "aria-label": "loading"
  }, props));
}, (prevProps, nextProps) => JSON.stringify(prevProps) === JSON.stringify(nextProps));
export default Spinner;